import React from 'react';
import { Box, Typography } from '@mui/material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { withLanguage } from '../common/Texts';
import { creditsTokens as t } from './tokens';

export default function CreditsHeader({ language, balance, count }) {
    const tr = withLanguage(language);

    return (
        <Box sx={{
            mb: 3,
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
        }}>
            <Box>
                <Typography component="h1" sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: t.color.fg,
                    lineHeight: 1.2,
                }}>
                    {tr('credits_history')}
                </Typography>
                <Typography sx={{ fontSize: 13, color: t.color.fgMuted, mt: 0.5 }}>
                    {count} {tr('movements')}
                </Typography>
            </Box>

            {Number.isFinite(balance) && (
                <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1.25,
                    px: 2,
                    py: 1.25,
                    borderRadius: `${t.radius.md}px`,
                    border: `1px solid ${balance === 0 ? t.color.danger : t.color.border}`,
                    backgroundColor: t.color.surface,
                }}>
                    <AccountBalanceWalletOutlinedIcon sx={{
                        fontSize: 20,
                        color: balance === 0 ? t.color.danger : t.color.fgMuted,
                    }}/>
                    <Box>
                        <Typography sx={{ fontSize: 11, color: t.color.fgSubtle, lineHeight: 1.2 }}>
                            {tr('current_balance')}
                        </Typography>
                        <Typography sx={{
                            fontSize: 20,
                            fontWeight: 700,
                            lineHeight: 1.2,
                            color: balance === 0 ? t.color.danger : t.color.fg,
                        }}>
                            {balance}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
}
